module.exports = __webpack_public_path__ + "img/provinceApply.1c724377.png";